var React = require('react');

function FlagVn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.725H8.828A8.829 8.829 0 010 414.897V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.793a8.83 8.83 0 01-8.829 8.828z","fill":"#ff4b55","key":0}),React.createElement("path",{"d":"M260.119 155.97l23.609 70.79 74.621.578c4.172.032 5.902 5.357 2.546 7.836l-60.029 44.329 22.509 71.147c1.259 3.978-3.271 7.27-6.666 4.843L256 312.1l-60.71 43.393c-3.394 2.426-7.924-.865-6.666-4.843l22.509-71.147-60.029-44.329c-3.357-2.478-1.626-7.804 2.546-7.836l74.621-.578 23.609-70.79c1.321-3.958 6.919-3.958 8.239 0z","fill":"#ffe15a","key":1})]);
}

FlagVn.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagVn;

FlagVn.default = FlagVn;
